import type { Project } from "../data/projects";

export default function ProjectArtwork({
  project,
  variant = "cover",
}: {
  project: Project;
  variant?: "cover" | "detail";
}) {
  if (!project.cover) return null;
  const cover = project.cover;
  return (
    <div className={`project-art project-image-art ${project.slug}-art ${variant}`}>
      <div className="project-image-frame">
        <img
          src={cover.src}
          width={cover.width}
          height={cover.height}
          alt={cover.alt}
          loading="lazy"
          decoding="async"
        />
      </div>
      <span className="project-image-caption mono">{cover.caption}</span>
    </div>
  );
}
